<template>
  <div>
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else>
      <card title="Question Form">
        <div class="row">
          <div class="col" :class="{ 'form-group--error': $v.form.question_type_id.$error }">
            <label for="select_question_type" class="control-label">{{ $t('manage_question.question_type') }}</label>
            <multiselect
              v-model="$v.form.question_type_id.$model"
              id="select_question_type"
              :loading="loadQuestionTypes"
              :options="questionTypes.map((type) => type.id)"
              :custom-label="(opt) => questionTypes.find((x) => x.id === opt).name"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
            <div v-if="$v.form.question_type_id.$error" class="mt-2">
              <div class="error" v-if="!$v.form.question_type_id.required">Field is required</div>
            </div>
          </div>

          <div class="col form-group" :class="{ 'form-group--error': $v.form.category_id.$error }">
            <label for="select_category" class="control-label">{{ $t('manage_question.category') }}</label>
            <multiselect
              v-model="form.category_id"
              id="select_category"
              :options="categories.map((category) => category.id)"
              :custom-label="(opt) => categories.find((x) => x.id === opt).name"
              :loading="loadCategories"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
              v-model.trim="$v.form.category_id.$model"
            >
            </multiselect>
            <div v-if="$v.form.category_id.$error" class="mt-2">
              <div class="error" v-if="!$v.form.category_id.required">Field is required</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" :class="{ 'form-group--error': $v.form.subcategory_id.$error }">
            <label for="select_subcategory" class="control-label">{{ $t('manage_question.subcategory') }}</label>
            <multiselect
              v-model="$v.form.subcategory_id.$model"
              :options="subcategories.map((subcategory) => subcategory.id)"
              :custom-label="(opt) => subcategories.find((x) => x.id === opt).name"
              id="select_subcategory"
              :loading="loadSubcategories"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
            </multiselect>
            <div v-if="$v.form.subcategory_id.$error" class="mt-2">
              <div class="error" v-if="!$v.form.subcategory_id.required">Field is required</div>
            </div>
          </div>

          <div class="col">
            <label for="select_consumption_category" class="control-label">Consumption Categories (optional)</label>
            <multiselect
              v-model="form.consumption_category_ids"
              :options="consumption_categories.map((consumption_category) => consumption_category.id)"
              :custom-label="(opt) => consumption_categories.find((x) => x.id === opt).name"
              id="select_consumption_category"
              :loading="loadConsumptionCategories"
              :multiple="true"
              :close-on-select="false"
              :show-labels="false"
            >
            </multiselect>
            <!--            <div v-if="$v.form.consumption_category_id.$error" class="mt-2">-->
            <!--              <div class="error" v-if="!$v.form.consumption_category_id.required">Field is required</div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="col form-group" :class="{ 'form-group--error': $v.form.question_text.$error }">
            <label class="control-label">Question Text (max: 255)</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Are you using natural/organic pest control products for the buildings?"
              maxlength="258"
              v-model="$v.form.question_text.$model"
            >
            </textarea>
            <div v-if="$v.form.description.$error" class="mt-2">
              <div class="error" v-if="!$v.form.description.required">Field is required</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col form-group" :class="{ 'form-group--error': $v.form.description.$error }">
            <label class="control-label">Description</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Write more information about this question. What should be done? What impact does this question has?"
              maxlength="258"
              v-model="$v.form.description.$model"
            >
            </textarea>
            <div v-if="$v.form.description.$error" class="mt-2">
              <div class="error" v-if="!$v.form.description.required">Field is required</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col relative z-10" :class="{ 'form-group--error': $v.form.unit_id.$error }">
            <label for="select_unit" class="control-label">{{ $t('manage_question.unit') }}</label>
            <multiselect
              v-model="form.unit_id"
              :options="units.map((unit) => unit.id)"
              id="select_unit"
              :loading="loadUnits"
              :multiple="false"
              :close-on-select="true"
              :show-labels="false"
            >
              <template slot="singleLabel" slot-scope="props">
                <div>
                  <span class="option__title text-uppercase mr-3">{{
                    units.find((x) => x.id === props.option).name
                  }}</span>
                  <span class="option__small">{{ units.find((x) => x.id === props.option).type }}</span>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title text-uppercase">{{ units.find((x) => x.id === props.option).name }}</span>
                  <span class="option__small">Type: {{ units.find((x) => x.id === props.option).type }}</span>
                </div>
              </template>
            </multiselect>
            <div v-if="$v.form.unit_id.$error" class="mt-2">
              <div class="error" v-if="!$v.form.unit_id.required">Field is required</div>
            </div>
          </div>
          <div class="col">
            <fg-input
              type="number"
              :class="{ 'form-group--error': $v.form.question_weight.$error }"
              label="Weight"
              placeholder="8"
              v-model.trim="$v.form.question_weight.$model"
            >
            </fg-input>
            <div v-if="$v.form.question_weight.$error">
              <div class="error" v-if="!$v.form.question_weight.required">Field is required</div>
              <div class="error" v-if="!$v.form.question_weight.numeric">Must be a positive number</div>
            </div>
          </div>
          <div v-if="showAnnualSequestrationField" class="col">
            <fg-input
              type="number"
              :class="{ 'form-group--error': $v.form.annual_sequestration_per_acre.$error }"
              label="Annual Sequestration Per Acre"
              placeholder="8"
              v-model.trim="$v.form.annual_sequestration_per_acre.$model"
            >
            </fg-input>
            <div v-if="$v.form.annual_sequestration_per_acre.$error">
              <div class="error" v-if="!$v.form.annual_sequestration_per_acre.required">Field is required</div>
              <div class="error" v-if="!$v.form.annual_sequestration_per_acre.numeric">Must be a positive number</div>
            </div>
          </div>
        </div>
        <div class="row" v-if="form.score_range">
          <div class="col">
            <fg-input
              type="text"
              :class="{ 'form-group--error': $v.form.score_range.min.$error }"
              label="Score range (bad)"
              placeholder="no"
              v-model.trim="$v.form.score_range.min.$model"
            >
            </fg-input>

            <div v-if="$v.form.score_range.min.$error">
              <div class="error" v-if="!$v.form.score_range.min.required">Field is required</div>
            </div>
          </div>
          <div class="col">
            <fg-input
              type="text"
              :class="{ 'form-group--error': $v.form.score_range.max.$error }"
              label="Score range (good)"
              placeholder="yes"
              v-model="$v.form.score_range.max.$model"
            >
            </fg-input>
            <div v-if="$v.form.score_range.max.$error">
              <div class="error" v-if="!$v.form.score_range.max.required">Field is required</div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-3">
            <label for="can_be_skipped" class="control-label">{{ $t('manage_question.can_be_skipped') }}</label>
            <fg-input
              id="can_be_skipped"
              type="radio"
              @checked="(isChecked) => (form.can_be_skipped = isChecked)"
              :selected="form.can_be_skipped"
            >
            </fg-input>
          </div>
          <div class="col-4">
            <label for="CO2_impact" class="control-label"> Does this question has an impact on CO2 Footprint? </label>
            <fg-input
              id="CO2_impact"
              type="radio"
              @checked="(isChecked) => (form.co2_impact = isChecked)"
              :selected="form.co2_impact"
            >
            </fg-input>
          </div>
          <div class="col-2">
            <label for="approved" class="control-label">{{ $t('manage_question.approved') }}</label>
            <div v-if="form.approved_at">{{ form.approved_at }} <span class="text-primary text-lg">&check;</span></div>
            <div v-else>
              <fg-input
                id="approved"
                type="radio"
                @checked="
                  (isChecked) => {
                    form.approved = isChecked;
                  }
                "
                :selected="form.approved_at"
              >
              </fg-input>
            </div>
          </div>
          <div v-if="form.suggestion === 1" class="col-3">
            <label class="control-label">{{ $t('Allow Publication') }}</label>
            <div>
              <span v-if="form.allow_publication === '1'" class="text-primary text-lg">&check;</span>
              <span v-else class="text-danger text-lg">&times;</span>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <div class="row">
          <div class="col">
            <DashboardElementCreateForm
              @formChanged="setDashForm($event.value)"
              :dashboard-element="dashForm"
              ref="dashboardElementCreateForm"
            />
          </div>
        </div>
        <div class="row flex justify-content-center align-items-center">
          <div>
            <p-button class="mr-3" type="success" :loading="loadingSave" round @click.native.prevent="submit(false)">
              {{ $t('save') }}
            </p-button>
            <p-button type="info" :loading="loadingSave" round @click.native.prevent="submit(true)">
              {{ $t('manage_question.btn_save_and_notify') }}
            </p-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';
import QuestionHasTypeController from '@/controllers/QuestionHasType/QuestionHasTypeController';
import CategoryController from '@/controllers/Category/CategoryController';
import SubcategoryController from '@/controllers/Category/SubcategoryController';
import UnitController from '@/controllers/Category/UnitController';
import DashboardElementCreateForm from '@/pages/Dashboard/DashboardElement/DashboardElementCreateForm';
import QuestionController from '@/controllers/Question/QuestionController';
import BackButton from '@/components/buttons/BackButton';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import { required, numeric, minValue, decimal, requiredIf } from 'vuelidate/lib/validators';
import ConsumptionCategoriesController from '@/controllers/Consumption/ConsumptionCategoriesController';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CreateQuestionForm',
  components: { MoonLoader, BackButton, DashboardElementCreateForm },
  props: {
    loadingSave: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('featureflag', ['features', 'isAnnualSequestrationFieldEnabled']),
    showAnnualSequestrationField() {
      return this.isAnnualSequestrationFieldEnabled && this.form.co2_impact && this.isAcresUnitSelected;
    },
    isAcresUnitSelected() {
      return !this.loadUnits && this.units.find(({ id }) => this.form.unit_id === id).name === 'acres';
    },
  },
  data() {
    return {
      loading: true,
      loadingQuestions: false,
      questionTypes: [],
      form: {
        annual_sequestration_per_acre: null,
        question_type_id: null,
        category_id: null,
        subcategory_id: null,
        consumption_category_ids: [],
        consumption_categories: [],
        question_weight: null,
        question_text: null,
        description: null,
        score_range: {
          max: null,
          min: null,
        },
        unit_id: null,
        can_be_skipped: true,
        approved: true,
        co2_impact: false,
      },
      categories: [],
      subcategories: [],
      units: [],
      dashForm: {},
      newDashForm: {},
      dashFormInvalid: false,
      loadCategories: false,
      loadQuestionTypes: false,
      loadSubcategories: false,
      loadUnits: false,
      loadConsumptionCategories: false,
    };
  },
  validations: {
    form: {
      subcategory_id: {
        required,
      },
      category_id: {
        required,
      },
      question_type_id: {
        required,
      },
      description: {
        required,
      },
      unit_id: {
        required,
      },
      question_text: {
        required,
      },
      question_weight: {
        required,
        numeric,
        minValue: minValue(1),
      },
      annual_sequestration_per_acre: {
        required: requiredIf(function (nestedModel) {
          return this.showAnnualSequestrationField;
        }),
        decimal,
      },
      score_range: {
        max: {
          required,
        },
        min: {
          required,
        },
      },
    },
  },
  async mounted() {
    this.setLoading();
    this.loadCategories = true;
    this.loadSubcategories = true;
    this.loadConsumptionCategories = true;
    this.loadUnits = true;
    this.loadQuestionTypes = true;
    await this.setForm();
    if (this.form) this.setDashForm(this.form.dashboard_element, false);

    Promise.all([
      this.getCategories(),
      this.getSubcategories(),
      this.getConsumptionCategories(),
      this.getUnits(),
      this.getQuestionTypes(),
      this.getFeatureFlags(),
    ]).then((response) => {
      this.categories = response[0];
      this.subcategories = response[1];
      this.consumption_categories = response[2];
      this.units = response[3];
      this.questionTypes = response[4];

      if (this.$route.name === 'Create Question') {
        let index = this.questionTypes.findIndex((questionType) => {
          return questionType.name === 'Initiative';
        });
        this.questionTypes.splice(index, 1);
      }

      this.loadQuestionTypes = false;
      this.loadCategories = false;
      this.loadSubcategories = false;
      this.loadConsumptionCategories = false;
      this.loadUnits = false;
      this.resetLoading();
    });
  },
  methods: {
    ...mapActions('featureflag', ['getFeatureFlags']),
    getQuestionTypes() {
      return QuestionTypeController.index();
    },
    setLoading() {
      this.loading = true;
    },
    resetLoading() {
      this.loading = false;
    },
    async getQuestionsOfType(questionType) {
      return (this.questions = await QuestionHasTypeController.show(questionType.id));
    },
    getCategories() {
      return CategoryController.index();
    },
    getSubcategories() {
      return SubcategoryController.index();
    },
    getUnits() {
      return UnitController.index();
    },
    submit(notify_users = false) {
      let newDashForm = this.dashForm;
      let newForm = this.form;
      this.$refs.dashboardElementCreateForm.submit();
      this.$v.$touch();
      if (this.$v.$invalid || !this.dashForm.icon_url || !this.dashForm.headline) {
        this.submitStatus = 'ERROR';
      } else {
        if (this.dashForm) {
          if (typeof this.dashForm.icon_url === 'string') {
            delete newDashForm.icon_url;
          }
        }

        if (typeof this.form.score_range == null) {
          delete newForm.score_range;
        }

        this.$emit('submit', {
          form: newForm,
          dashForm: newDashForm,
          consumption_category_ids: this.form.consumption_category_ids,
          notify_users: notify_users,
        });
      }
    },
    async setForm() {
      if (this.$route.params.questionId) {
        const result = await QuestionController.show(this.$route.params.questionId);
        this.form = {
          ...this.form,
          ...result,
          score_range: result.score_range || this.form.score_range,
        };
      }
    },
    setDashForm(dashForm) {
      if (this.form) this.dashForm = dashForm;
    },
    getConsumptionCategories() {
      return ConsumptionCategoriesController.index();
    },
  },
};
</script>

<style scoped>
.error {
  display: block;
  color: #f57f6c;
  font-size: 1.2rem;
  line-height: 1;
  margin-left: 14px;
  margin-bottom: 0.9375rem;
}

.error:focus {
  outline-color: #f99;
}
.form-group--error input,
.form-group--error textarea {
  border-color: #f04124 !important;
}
</style>
